import axiosInstance from './axiosInstance';

export const createDesignRequest = (dto) => axiosInstance.post('/DesignRequest/Create', dto);
export const listDesignRequests = () => axiosInstance.get('/DesignRequest/List');
export const getDesignRequest = (id) => axiosInstance.get(`/DesignRequest/Detail/${id}`);
export const updateDesignRequest = (id, dto) => axiosInstance.post(`/DesignRequest/Update/${id}`, dto);
export const markDesignDone = (id) => axiosInstance.post(`/DesignRequest/MarkDone/${id}`);
export const cancelDesignRequest = (id) => axiosInstance.post(`/DesignRequest/Cancel/${id}`);
// Designer uploads finished work (gallery). images: [{ dataBase64, fileName }], ≤5 MB each.
export const uploadDesignDrawings = (id, images) => axiosInstance.post(`/DesignRequest/UploadDrawings/${id}`, { images });
